<template lang="html">
  <footer id="footer">

  	<div class="container oversized-container footer-content">
			<div class="row">
				<div class="col-sm-6 col-lg col-footer">
					<h5 class="title">{{ $t("footer.titles.addresstitle") }}</h5>

					<p>
						{{ $t("footer.titles.address1") }}<br />
						{{ $t("footer.titles.address2") }}
					</p>
				</div>
				<div class="col-sm-6 col-lg col-footer">
					<h5 class="title">{{ $t("footer.titles.phone") }}</h5>
					<p>
						801 759 5815
					</p>
          <p class="mt-2">
            <!--router-link to="/privacy-policy">Aviso de Privacidad</router-link-->
          </p>
				</div>

				<div class="col-12 col-lg col-footer col-logo">
					<img src="public/images/logo.svg">
				</div>

				<div class="col-sm-6 col-lg col-footer">
					<h5 class="title">{{ $t("footer.titles.email") }}</h5>
					<p>
						<a href="mailto:info@eslowindows.com">info@eslowindows.com</a>
						<!-- <a href="mailto:contacto@eslowindows.com">contacto@eslowindows.com</a> -->
					</p>
				</div>
				<div class="col-sm-6 col-lg col-footer">
					<h5 class="mb-1 title">{{ $t("footer.titles.web") }}</h5>
					<p>
            <!-- <router-link to="/distribuidores">{{ $t("footer.titles.dealers") }}</router-link><br /> -->
            <router-link to="/articles">Blog</router-link><br />
            <router-link to="/downloads">{{ $t("footer.titles.downloads") }}</router-link><br />
            <router-link to="/privacy-policy">{{ $t("footer.titles.privacy") }}</router-link><br />
            <!-- <router-link to="/garantias">{{ $t("footer.titles.warranties") }}</router-link><br /> -->
            <router-link to="/contacto">{{ $t("footer.titles.contact") }}</router-link>
					</p>
				</div>
			</div>
  	</div>

  </footer>
</template>

<script>
export default {
}
</script>
